export const ENDPOINTS = {
  AUTH: 'auth',
  BULK_ACTION: 'bulk-actions',
  CHANNEL: 'channels',
  CHANNEL_PRODUCT: 'channel-products',
  EXPORT: 'exports',
  GATE_PASS: 'gate-passes',
  GRN: 'grns',
  INVENTORY: 'inventory',
  MANIFEST: 'manifests',
  ME: 'me',
  ORDER: 'orders',
  PICKLIST: 'picklists',
  PRODUCT: 'products',
  PRODUCT_BRAND_NAME: 'products/brands/name',
  PRODUCT_NAME: 'products/name',
  PURCHASE_ORDER: 'purchase-orders',
  PUT_AWAY: 'put-away',
  RECORDING: 'recordings',
  RETURN_MANIFEST: 'return-manifests',
  SEARCH: 'search',
  SHELF: 'shelves',
  SHIPMENT: 'shipments',
  VENDOR: 'vendors',
  VENDOR_NAME: 'vendors/name',
  WAREHOUSE: 'warehouses',
  STOCKTAKING: 'stocktakings',
  // admin
  MANAGEMENT_ORDER: 'management/orders',
  MANAGEMENT_SEQUENCE: 'management/prefixed-sequence',
  MANAGEMENT_SHELF: 'management/shelves',
  MANAGEMENT_SHIPPING_PROVIDER: 'management/shipping-providers',
  MANAGEMENT_USER: 'management/users',
  MANAGEMENT_VENDOR: 'management/vendors',
  MANAGEMENT_WAREHOUSE: 'management/warehouses',
};
